import { useEffect } from 'react';
import { StatusBar, Style } from '@capacitor/status-bar';
import { isNativePlatform } from './platform';

export const useStatusBar = () => {
  useEffect(() => {
    if (!isNativePlatform()) return;

    const setup = async () => {
      try {
        await StatusBar.setStyle({ style: Style.Dark });
        await StatusBar.setBackgroundColor({ color: '#6D28D9' });
      } catch (e) {
        console.debug('StatusBar setup failed:', e.message);
      }
    };
    setup();
  }, []);
};

export const setStatusBarLight = async () => {
  if (!isNativePlatform()) return;
  try {
    await StatusBar.setStyle({ style: Style.Light });
    await StatusBar.setBackgroundColor({ color: '#FFFFFF' });
  } catch (e) {
    console.debug('StatusBar light failed:', e.message);
  }
};

export const setStatusBarDark = async () => {
  if (!isNativePlatform()) return;
  try {
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#6D28D9' });
  } catch (e) {
    console.debug('StatusBar dark failed:', e.message);
  }
};
